import { createApi, fetchData, formatParams, getApi, updateApi } from '@/lib/api.service.js'

const currentUrl = `${import.meta.env.VITE_BACKEND_URL}/api/v2/servicechek/user_notification_settings`;

export async function indexUserNotificationSettings(params = null) {
  try {
    return await fetchData(currentUrl, params);
  } catch (e) {
    console.error(e);
    throw e;
  }
}

export async function getUserNotificationSetting(id){
  try {
    let url = `${currentUrl}/${id}`;
    const response = await getApi(url);

    if (response.status >= 200 && response.status < 300) {
      return response.json
    } else {
      throw new Error(response.json.error);
    }
  } catch (e) {
    console.error(e);
    throw e;
  }
}

export async function createUserNotificationSetting(data) {
  data = { servicechek_user_notification_setting: data };

  try {
    const response = await createApi(currentUrl, data);

    if (response.status >= 200 && response.status < 300) {
      return response.json
    } else {
      throw new Error(response.json.error);
    }
  } catch (e) {
    console.error(e);
    throw e;
  }
}

export async function updateUserNotificationSetting(id, data) {
  data = { servicechek_user_notification_setting: data };

  try {
    let url = `${currentUrl}/${id}`;
    const response = await updateApi(url, data);

    if (response.status >= 200 && response.status < 300) {
      return response.json
    } else {
      throw new Error(response.json.error);
    }
  } catch (e) {
    console.error(e);
    throw e;
  }
}